<template>
    <div class="col-sm-8 col-md-6 col-lg-4 fiber-offer">
        <div class="input-group my-3">
            <div>
                <label for="postal">
                    {{$t('Postal code')}}
                </label>
            </div>
            <div class="d-flex mt-1">
                <ValidationProvider class="postValidator" name="postal" rules="required|postal" v-slot="{ errors }">

                    <input
                        type="text"
                        pattern="[0-9]*"
                        id="postal"
                        class="form-control is-required mr-3"
                        :title="postalCode"
                        v-model="postalCode"
                        placeholder="L-1234"
                        @keydown="handlePostalCodeKeydown"
                        @input="handlePostalCodeInput"
                        @focus="handlePostalCodeFocus"
                        @keyup.enter="getAddresses"
                        :disabled="secondForm === true">
                    <span v-if="showValidationMessage" :class="[errors.length > 0 ? 'invalid-feedback u-flex' : '']">
                        {{ errors[0] }}
                    </span>
                    <span v-if="showPostalNotFound" :class="'invalid-feedback u-flex'">
                        {{ $t('Post code not recognized.') }}
                    </span>
                </ValidationProvider>

                <button v-if="secondForm" @click="onEdit()" type="button" class="btn btn-link lh-1">{{$t('Edit')}}</button>
                <button v-else class="btn btn-primary lh-1" type="button" @click="getAddresses">{{$t('Check')}}</button>
                <!-- <button v-else class="btn btn-primary lh-1" type="button" :disabled="!isValidPostalCode" @click="getAddresses">Check</button> -->

                <div v-show="isLoading">
                    <img
                        :src="planDataFromMagento.loaderUrl"
                        class="ml-3"
                        style="max-width: 36px;"
                        alt=""/>
                </div>
            </div>
        </div>
        <div v-if="secondForm" class="c-plan-form__keep-phone-number u-pad-t-sm u-marg-b-sm border-top border-500">


            <div class="px-0 col-12">
                <label for="city"> {{$t('City')}} </label>
            </div>
            <div class="px-0 form-group col-12 col-sm-12 col-md-12">
                <input disabled type="text" class="form-control is-required" :placeholder="cityPlaceholder">
            </div>

            <div class="row mx-0">
                <div class="px-0 pr-md-2 form-group col-12 col-md-8 mb-0">
                    <label for="street name"> {{$t('Street name')}}</label>
                    <div>
                        <div class="form-group">
                            <select id="providerSelect" class="custom-select is-required" v-model="selectedStreet">
                                <option v-for="item in uniqueStreet" :key="item.addressID"> {{ item.street }} </option>
                            </select>
                        </div>
                    </div>
                </div>

                <div class="px-0 form-group col-12 col-md-4 mb-0">
                    <label for="street number"> {{$t('Street number')}}</label>
                    <div>
                        <div class="form-group">
                            <select :disabled="!selectedStreet" id="providerSelect" class="custom-select is-required" v-model="selectedStreetItem">
                                <option v-for="(item, i) in uniqueStreetNumber" :key="i" :value="item"> {{ item.streetNumber }} </option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>

            <div class="px-0 col-12">
                <label for="postalCode"> {{$t('Additional information')}}</label>
            </div>
            <div class="px-0 form-group col-12 col-sm-12 col-md-12">
                <select :disabled="!selectedStreetItem || !selectedStreetItem.streetNumber"
                        id="providerSelect"
                        class="custom-select is-required"
                        v-model="selectedAdditionalInfoItem">
                    <option v-for="(item, i) in additionalInfoList" :key="i" :value="item">
                        {{ formatAdress(item) }}
                    </option>
                </select>
            </div>
            <div class="px-0 col-12 col-sm-12 col-md-12">
                <button
                    @click="nextStep"
                    type="button"
                    id="next-step"
                    class="btn btn-lg btn-primary"
                    :disabled="!selectedStreet || !selectedStreetNumber || !selectedAdditionalInfoItem.addressID">
                    {{$t('Next step')}}
                </button>
                <img
                    v-show="isLoadingSamId"
                    :src="planDataFromMagento.loaderUrl"
                    class="ml-3"
                    style="max-width: 36px;"
                    alt=""/>

                <div v-show="isError" class="alert alert-danger mt-3" role="alert">
                    <span class="alert-icon"><span class="sr-only">Danger</span></span>
                    <div>{{$t('An error has occurred, please try again later.')}}</div>
                </div>
            </div>
        </div>



    </div>
</template>


<script>

import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import axios from 'axios';
import Helpers from "../../plugins/Helpers";

export default {
    data() {
        return {
            postalCode: '',
            isValidPostalCode: false,
            secondForm: false,
            isLoading: false,
            response: [],
            cityPlaceholder: '',
            uniqueStreet:[],
            uniqueStreetNumber: [],
            selectedStreetItem: { streetNumber: null },
            selectedAdditionalInfoItem: null,
            selectedStreet: '',
            selectedStreetNumber: '',
            samIdResponse: [],
            isLoadingSamId: false,
            isError: false,
            showValidationMessage: false,
            showPostalNotFound: false
        }
    },
    components: {
        ValidationProvider,
        ValidationObserver
    },

    props: {
        traduction: {
            type: Function
        },
        planDataFromMagento: {
            type: Object,
            default: () => null
        }
    },
    computed: {
        $t() {
            return this.traduction
        },
    },
    watch:{
        secondForm: function () {
            this.selectedStreetNumber = ''
            this.selectedStreet = ''
            this.selectedStreetItem = {}
            this.selectedAdditionalInfoItem = {}
            if(this.uniqueStreet && this.uniqueStreet.length === 1){
                this.selectedStreet = this.uniqueStreet[0].street
            }
        },
        selectedStreet: function (newValue) {
            // Check if the street exists in the map and get street numbers
            const streetNumbers = this.streetNumberMap[newValue] || [];

            // Set uniqueStreetNumber to the filtered list and sort by street number
            this.uniqueStreetNumber = streetNumbers
                .sort((a, b) => a.streetNumber - b.streetNumber);

            if (this.uniqueStreetNumber.length === 1) {
                this.selectedStreetItem = this.uniqueStreetNumber[0];
            }
        },

        selectedStreetItem: function (newValue) {
            if (!newValue || typeof newValue.streetNumber === 'undefined') {
                return
            }

            this.selectedStreetNumber = newValue.streetNumber;
            this.additionalInfoList = this.response.filter(item => item.street === this.selectedStreet && item.streetNumber === this.selectedStreetNumber);

            if (this.additionalInfoList && this.additionalInfoList.length === 1) {
                this.selectedAdditionalInfoItem = this.additionalInfoList[0];
            }
        }
    },
    mounted(){
        let currentState = JSON.parse(window.localStorage.getItem('mage-cache-storage-installation'));

        // Check if the postal code is available in the saved state
        if (currentState && currentState.address && currentState.address.postalCode) {
            this.postalCode = currentState.address.postalCode
            this.isValidPostalCode = true;
            this.secondForm = true;

            // Automatically fetch addresses based on the pre-filled postal code
            this.getAddressesInBackground(this.postalCode);
        }

        this.extendValidation()
    },
    methods:{
        handlePostalCodeKeydown(event) {
            this.showPostalNotFound = false
            this.showValidationMessage = false
            const key = event.which || event.keyCode;
            const allowedKeys = [8, 46, 9, 37, 38, 39, 40]; // Allow backspace, delete, tab and arrow keys

            if (allowedKeys.includes(key)) {
                return;
            }

            // Allow only numeric input and limit to 4 digits
            if ((key >= 48 && key <= 57) || (key >= 96 && key <= 105)) {
                if (this.postalCode.length >= 6) {
                    event.preventDefault();
                }
            } else {
                event.preventDefault();
            }
        },
        handlePostalCodeInput() {
            // Format the postal code with 'L-' prefix and limit to 4 digits
            this.postalCode = this.formatPostalCode(this.postalCode);
            this.showPostalNotFound = false
            this.showValidationMessage = false
        },
        handlePostalCodeFocus() {
            this.showPostalNotFound = false
            this.showValidationMessage = false
            if (this.postalCode === "" || this.postalCode.indexOf("L-") !== 0) {
                this.postalCode = "L-";
            }
        },
        formatPostalCode(value) {
            if (value.indexOf("L-") !== 0) {
                return "L-" + value.replace(/[^0-9]/g, "").substring(0, 4);
            } else {
                return "L-" + value.substring(2).replace(/[^0-9]/g, "").substring(0, 4);
            }
        },
        formatAdress(item){
            if(item.building == null && item.floor == null && item.apartment == null){
                return '-'
            }else{
                let address = (item.building != null ? 'Building ' + item.building + ', ' : '') + (item.floor != null ? 'Floor. ' + item.floor + ', ': '') + (item.apartment != null ? 'Apt. ' + item.apartment : '')
                let returnAddress = address.substring(address.length - 2) === ', ' ? address.slice(0, -2) : address
                return returnAddress
            }
        },
        getAddressesInBackground(postalCode) {
            this.isLoading = true;

            let base_url = window.location.origin;
            let relative_path = `/olu_eligibitytest?postal_code=${postalCode}`;
            let full_url = `${base_url}${relative_path}`;

            axios.get(full_url, {
                headers: {
                    'Method': 'GET',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer lHA4DWpwc52HYxbyHXP9pIt9cZE8Lli0DgiGkCddQvonbTHN',
                    'Content-Type': 'application/json; charset=utf-8'
                },
                responseType: 'json',
            })
                .then(response => {
                    this.response = response.data
                    this.uniqueStreet = [...new Map(response.data.map(item => [item['street'], item])).values()].sort((a, b) => a.street.localeCompare(b.street));
                    this.uniqueCity = [...new Set(response.data.map(item => item['city']))];
                    this.cityPlaceholder = this.uniqueCity.length > 0 ? this.uniqueCity[0] : "Luxembourg";

                    // Create a map to group street numbers by street and sort them naturally (e.g., 1, 2, 2A, 2B)
                    this.streetNumberMap = this.response.reduce((map, item) => {
                        if (!map[item.street]) {
                            map[item.street] = []
                        }

                        // Add street numbers only if they are unique
                        if (!map[item.street].some(sn => sn.streetNumber === item.streetNumber)) {
                            map[item.street].push(item)
                        }

                        // Sort street numbers naturally
                        map[item.street].sort((a, b) => {
                            const [numA, suffixA] = splitStreetNumber(a.streetNumber)
                            const [numB, suffixB] = splitStreetNumber(b.streetNumber)

                            // First, compare the numeric part
                            if (numA !== numB) {
                                return numA - numB
                            }
                            // If numeric parts are equal, compare the letter suffix
                            return suffixA.localeCompare(suffixB)
                        });

                        return map;
                    }, {});

                    // Function to split street numbers into numeric and alphanumeric parts safely
                    function splitStreetNumber(streetNumber) {
                        const match = streetNumber.match(/^(\d+)(\D*)$/)

                        if (!match) {
                            // If the match fails, return a high number to sort invalid entries at the end
                            return [Infinity, '']
                        }

                        return [parseInt(match[1], 10), match[2] || '']
                    }

                    // Prefill selected street and street number from currentState
                    let currentState = JSON.parse(window.localStorage.getItem('mage-cache-storage-installation'))
                    if (currentState && currentState.address) {
                        // Extract street names from uniqueStreet
                        const streetNames = this.uniqueStreet.map(item => item.street);

                        // Set selected street if it exists in the API response
                        if (streetNames.includes(currentState.address.street)) {
                            this.selectedStreet = currentState.address.street;
                        }

                        // Set selected street number if it exists in the current state
                        const streetNumbers = this.streetNumberMap[this.selectedStreet];
                        if (streetNumbers && streetNumbers.some(sn => sn.streetNumber === currentState.address.streetNumber)) {
                            this.selectedStreetItem = streetNumbers.find(sn => sn.streetNumber === currentState.address.streetNumber);
                        }

                        // Set additional info based on selected street and street number
                        if (this.selectedStreetItem) {
                            this.additionalInfoList = this.response.filter(item =>
                                item.street === this.selectedStreet &&
                                item.streetNumber === this.selectedStreetItem.streetNumber
                            );

                            this.selectedAdditionalInfoItem = this.additionalInfoList.filter(item => item.samID === currentState.address.additionalInfo.samID)[0]
                        }
                    }

                    if (response.data.length){
                        this.secondForm = true
                        Helpers.pushDataLayer({
                            'event': 'configurator_field',
                            'step': 'fibre_postcode_checked'
                        });

                    } else {
                        this.showPostalNotFound = true;
                    }

                    this.isLoading = false
                })
                .catch(error => {
                    this.isLoading = false
                    this.isError = true
                    setTimeout(() => {
                        this.isError = false
                    }, 5000);
                    console.error('Error:', error);
                });
        },
        getAddresses() {
            this.showValidationMessage = true;
            this.showPostalNotFound = false;

            if (!this.isValidPostalCode) {
                return;
            }

            this.getAddressesInBackground(this.postalCode);
        },

        nextStep(){
            let currentState = JSON.parse(window.localStorage.getItem('mage-cache-storage-installation'))
            let formatPayload = {
                street: this.selectedStreet,
                streetNumber: this.selectedStreetNumber,
                additionalInfo: this.selectedAdditionalInfoItem,
                postalId: this.selectedAdditionalInfoItem.samID,
                postalCode: this.postalCode ?? currentState.address.postalCode
            }
            document.cookie = "additionalInfo=" + JSON.stringify(this.selectedAdditionalInfoItem) + "; expires=Fri, 31 Dec 2199 23:59:59 GMT; path=/"
            window.localStorage.setItem('mage-cache-storage-installation',  JSON.stringify( currentState = {...currentState, address: formatPayload} ));

            this.isLoadingSamId = true

            let base_url = window.location.origin;
            let relative_path = `/olu_eligibityinformation/information/index?sam_id=${formatPayload.postalId}`;
            let full_url = `${base_url}${relative_path}`;

            axios.get(full_url, {
                headers: {
                    'Method': 'GET',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer lHA4DWpwc52HYxbyHXP9pIt9cZE8Lli0DgiGkCddQvonbTHN',
                    'Content-Type': 'application/json; charset=utf-8'
                },
                responseType: 'json',
            })
            .then(response => {
                this.isLoadingSamId = false
                this.samIdResponse = response.data

                if(Array.isArray(this.samIdResponse) && this.samIdResponse.length){
                    // let filteredResponse = this.samIdResponse.filter(e => this.planDataFromMagento.plan.plan_sku.includes(e.speedValue))
                    let filteredResponse = []
                    if( window.planDataFromMagento.plan.plan_sku === "OFFRE_LIVEBOX_FIBRE_2G"){
                        filteredResponse = [this.samIdResponse[1]]
                    }else{
                        filteredResponse = [this.samIdResponse[0]]
                    }

                    let filteredSam = (Array.isArray(filteredResponse) && filteredResponse.length > 0 && filteredResponse[0])
                        ? {
                            samID: filteredResponse[0]?.samID ?? null,
                            speedType: filteredResponse[0]?.speedType ?? null,
                            speedValue: filteredResponse[0]?.speedValue ?? null,
                            technology: filteredResponse[0]?.technology ?? null,
                            name: filteredResponse[0]?.name ?? null
                        }
                        : {
                            samID: null,
                            speedType: null,
                            speedValue: null,
                            technology: null,
                            name: null
                        };


                    if (filteredSam.samID !== null && filteredSam.technology !== null ) {
                        console.log('samID is not null:', filteredSam.samID);
                        Helpers.pushDataLayer({
                            'event': 'configurator_field',
                            'step': 'fibre_postcode_checked'
                        });

                        this.$emit('eligibility-status', {status: true, value: filteredSam})
                        this.$emit('next-step', true)
                    } else {
                        this.$emit('eligibility-status', {status: false})
                    }
                }else{
                    this.$emit('eligibility-status', {status: false})
                }
            })
            .catch(error => {
                this.isLoadingSamId = false
                this.isError = true
                setTimeout(() => {
                    this.isError = false
                }, 5000);
                console.error('Error:', error);
            });
        },

        extendValidation() {
            extend('required', {
                ...required,
                message: this.$t('This field is required')
            });

            extend("postal", (value) => {
                const checkRegex = /^L-\d{4}$/.test(value);
                this.isValidPostalCode = checkRegex;

                if (!checkRegex) {
                    return this.$t('Please provide a valid Postal code. Example: L-1234')
                } else {
                    return true;
                }
            });

        },

        onEdit() {
            this.secondForm = false
            localStorage.removeItem('mage-cache-storage-installation')
        }
    }


}
</script>
